import type { SxProps, Theme } from "@mui/material";
import { type Control, Controller, type FieldValues, type Path } from "react-hook-form";
import { type DifficultyCoachingLevel, DifficultyToggleGroup } from "../../DifficultyToggleGroup";

interface IDifficultyToggleGroupFormProps<T extends FieldValues = FieldValues> {
  control: Control<T>;
  name: Path<T>;
  color?: Record<DifficultyCoachingLevel, string>;
  sx?: SxProps<Theme>;
}

export const DifficultyToggleGroupForm = <T extends FieldValues = FieldValues>({
  control,
  name,
  color,
  sx,
}: IDifficultyToggleGroupFormProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      // error is used here to force react hook form to re-render the component, you must keep it even if you don't use it
      render={({ field: { onChange, value } }) => (
        <DifficultyToggleGroup onChange={onChange} value={value} color={color} sx={sx} />
      )}
    />
  );
};
